import { apiClient } from "@/lib/apiClient";
import type {
  ContadorEmpresa,
  DocumentoFiscalContador,
  EnviarNotasPainelResultado,
  EnviarPacoteContadorRequest,
  InutilizadoContador,
  PacoteContadorResultado,
  PainelSyncResultado,
} from "../types/plataformaContador";

const BASE = "/api/contabil/plataforma-contador";

export interface FiltroDocumentos {
  empresaId: number;
  dtInicio: string;
  dtFim: string;
  modelo?: number;
  tipo?: number;
}

export const plataformaContadorService = {
  listarDocumentos: async (f: FiltroDocumentos) => {
    const { data } = await apiClient.get<DocumentoFiscalContador[]>(`${BASE}/documentos`, {
      params: { empresaId: f.empresaId, dtInicio: f.dtInicio, dtFim: f.dtFim, modelo: f.modelo ?? 0, tipo: f.tipo ?? -1 },
    });
    return data;
  },

  obterContador: async (empresaId: number) => {
    const { data } = await apiClient.get<ContadorEmpresa>(`${BASE}/contador`, { params: { empresaId } });
    return data;
  },

  listarInutilizados: async (f: { empresaId: number; dtInicio: string; dtFim: string }) => {
    const { data } = await apiClient.get<InutilizadoContador[]>(`${BASE}/inutilizados`, { params: f });
    return data;
  },

  baixarZip: async (req: EnviarPacoteContadorRequest) => {
    const resp = await apiClient.post(`${BASE}/pacote-zip`, req, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([resp.data as BlobPart]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `NotasFiscais_${req.dtInicio.replace(/-/g, "")}_a_${req.dtFim.replace(/-/g, "")}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
  },

  enviarEmail: async (req: EnviarPacoteContadorRequest) => {
    const { data } = await apiClient.post<PacoteContadorResultado>(`${BASE}/enviar-email`, req);
    return data;
  },

  // ── Nuvem Painel Contador ──
  sincronizarContador: async (empresaId: number) => {
    const { data } = await apiClient.post<PainelSyncResultado>(`${BASE}/painel/sincronizar-contador`, { empresaId });
    return data;
  },
  sincronizarCliente: async (empresaId: number) => {
    const { data } = await apiClient.post<PainelSyncResultado>(`${BASE}/painel/sincronizar-cliente`, { empresaId });
    return data;
  },
  enviarNotasPainel: async (req: { empresaId: number; dtInicio: string; dtFim: string; modelo?: number; tipo?: number }) => {
    const { data } = await apiClient.post<EnviarNotasPainelResultado>(`${BASE}/painel/enviar-notas`, req);
    return data;
  },
};
